export default __webpack_public_path__ + "static/media/055-light bulb.47094423.svg";